'use client'

import { X24 } from '@vinted/monochrome-icons'
import { Button, Icon, Navigation } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const NavigationCloseButton = ({ handleClose }) => {
  const translate = useTranslate('common.a11y.actions')

  return (
    <Navigation
      right={
        <Button
          styling={Button.Styling.Flat}
          onClick={handleClose}
          icon={<Icon name={X24} testId="icon-x" />}
          inline
          testId="seller-protection-navigation-close"
          aria={{ 'aria-label': translate('dialog_close') }}
        />
      }
    />
  )
}

export default NavigationCloseButton
